module.exports = __webpack_public_path__ + "img/engagement_goutte_eau.f2eb3da0.svg";